import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { Container, Text, Image } from './styles';

const EmailInvalid = ({ isDarkMode }) => {
  const intl = useIntl();

  return (
    <Container>
      <Image $isDarkMode={isDarkMode} />

      <Text $isDarkMode={isDarkMode}>
        {intl.formatMessage({ id: 'authModal.register.notAValidEmail' })}
      </Text>
    </Container>
  );
};

EmailInvalid.propTypes = {
  isDarkMode: PropTypes.bool.isRequired,
};

export default EmailInvalid;
